var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDealResult(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.284 8.082l-2.277 12.35a.412.412 0 00.577.453L6 20.22a.406.406 0 01.413.04l1.657 1.207c.12.088.278.103.413.04l2.032-.954a.408.408 0 01.225-.035l1.326.17a.412.412 0 00.462-.404l.2-11.368a.414.414 0 00-.356-.42l-5.631-.75a.411.411 0 00-.458.336z",
    fill: "#9B9CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.935 8.204l2.813 13.465 1.76-1.934 2.456.586 1.76-1.934 2.455.586-5.027-12.451-6.217 1.682z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.94 5.72c.4-.109.816.1.972.488l5.027 12.451a.838.838 0 01-.136.854.816.816 0 01-.813.268l-1.988-.474-1.434 1.577a.815.815 0 01-.793.245l-1.988-.474-1.435 1.577a.815.815 0 01-.821.238.827.827 0 01-.586-.629L7.132 8.376a.831.831 0 01.591-.974L13.94 5.72zM8.9 8.803l2.322 11.119.682-.75a.816.816 0 01.793-.245l1.988.474 1.434-1.576a.815.815 0 01.793-.246l.904.216-4.15-10.282L8.9 8.803z",
    fill: "#9B9CA2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "dealResult_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 11,
    height: 11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35 7.515l3.283-.903-.403 3.492 2.422 2.553 3.912-6.852L11.52 2.5l-5.046.798.875 4.217z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dealResult_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.592 5.247c-.672-.222-1.672.235-2.055 1.42-.184.569-.15 1.125.023 1.555l-1.525.627c-.327-.813-.361-1.775-.063-2.7.576-1.783 2.346-3.074 4.131-2.484 1.74.574 2.529 2.526 1.935 4.364-.284.88-.816 1.817-1.677 2.307a.818.818 0 01-1.12-.318.837.837 0 01.313-1.133c.349-.199.695-.68.92-1.373.364-1.13-.163-2.027-.882-2.265z",
    fill: "#9B9CA2"
  }))));
}
export default SvgDealResult;